import { Car, Driver, Employee, Subdivision, AppealType } from '~/shared/api'
import { AppealsStatusEnumOptions } from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid'

export const filters: Filter[] = [
  {
    field: 'createdAtFrom',
    label: 'filter.period start',
    type: 'date',
  },
  {
    field: 'createdAtTo',
    label: 'filter.period end',
    type: 'date',
  },
  {
    field: 'status',
    label: 'filter.status',
    type: 'select',
    options: AppealsStatusEnumOptions,
  },
  {
    field: 'amount',
    label: 'filter.amount',
    type: 'price',
  },
  {
    field: 'driverId',
    label: 'filter.driver',
    type: 'autocomplete',
    fetchOptions: Driver.fetchOptions,
  },
  {
    field: 'carId',
    label: 'filter.car',
    type: 'autocomplete',
    fetchOptions: Car.fetchOptions,
  },
  {
    field: 'subdivisionId',
    label: 'filter.subdivision',
    type: 'autocomplete',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    field: 'appealTypeId',
    label: 'filter.request type',
    type: 'autocomplete',
    fetchOptions: AppealType.fetchOptions,
  },
  {
    field: 'creatorId',
    label: 'filter.initiator',
    type: 'autocomplete',
    fetchOptions: Employee.fetchOptions,
  },
  {
    field: 'creatorComment',
    label: 'filter.initiator comment',
    type: 'text',
  },
  {
    field: 'responsibleId',
    label: 'filter.responsible',
    type: 'autocomplete',
    fetchOptions: Employee.fetchOptions,
  },
  {
    field: 'responsibleComment',
    label: 'filter.responsible comment',
    type: 'text',
  },
]
